import React from "react";
import Body from "./middle/Body";
import HeaderLogoOnly from "../header/HeaderLogoOnly";
import Footer from "../footer/FooterCopyrightOnly";

export default function Privacy() {
    return (
        <>
            <HeaderLogoOnly/>
            <Body/>
            <Footer/>
        </>
    );
}